export default {
  'about': {
    'title': 'Full-Stack Software Engineer',
    'summary': 'I\'m a front-end leaning full-stack software engineer with an entrepreneurial background in front-end web development, SEO, and education. I\'m enthusiastic about creating code that solves human-centered problems and I love learning and teaching new techniques and technologies.',
    'pitch': 'As a full-stack web engineer role at a startup, I spent the past fifteen months working on all kinds of web-based software and plugins to aid with and automate multi-departmental processes.',
    'history': 'I\'m fascinated by the ways digital technology can engage and empower people. Since earning my U of O degree in Multimedia Design, I\'ve spent more than a decade helping people harness the power of that technology. I\'ve taught classes for young people, tutored older people, consulted for small businesses, co-authored technology textbooks, served as both design and IT department for a small media company, and designed and developed websites and software for businesses, nonprofits, and individuals.',
  },
  'contact': {
    'heading': 'Let\'s Connect!',
    'tagline': 'import SoftwareEngineer from \'benbeekman.dev\';',
    'hiringStatus': 'Contact me using any of the options below.',
    'name': 'Ben Beekman',
    'occupation': 'Software Engineer',
    'email': 'ben@benbeekman.dev',
    'phone': '(503)708-0478',
    'city': 'Portland',
    'state': 'OR',
    'linkedinURL': 'https://www.linkedin.com/in/beekman/',
    'githubURL': 'https://github.com/beekman',
    'resumeLink': 'https://www.dropbox.com/scl/fi/cdit7mem2vpeor1yeynoi/Ben_Beekman_CV.pdf?rlkey=declt330cokkgdpstuo6zx3ap&dl=0',
  },
  'skills': {
    'heading': 'Tools of My Trade',
    'techHeading': 'I use these',
    'techCopy': 'I create digital solutions with a modern tech stack centered around functional, declarative JavaScript. I am always excited to add new tools to that stack.',
    'tech': [
      {
        'name': 'JavaScript',
      },
      {
        'name': 'TypeScript',
      },
      {
        'name': 'React',
      },
      {
        'name': 'Redux',
      },
      {
        'name': 'Node',
      },
      {
        'name': 'MongoDB',
      },
      {
        'name': 'PostgreSQL',
      },
      {
        'name': 'Express',
      },
      {
        'name': 'Mongoose',
      },
      {
        'name': 'Jest',
      },
      {
        'name': 'TravisCl',
      },
      {
        'name': 'Git',
      },
      {
        'name': 'Shell'
      },
      {
        'name': 'Netlify',
      },
      {
        'name': 'Heroku',
      },
      {
        'name': 'D3',
      },
      {
        'name': 'MagentaJS',
      },
      {
        'name': 'ToneJS',
      },
      {
        'name': 'P5JS',
      },
      {
        'name': 'ML5'
      },
      {
        'name': 'Python',
      },
      {
        'name': 'PHP',
      },
      {
        'name': 'SASS',
      },
      {
        'name': 'HTML',
      },
      {
        'name': 'CSS',
      },

    ],
    'learningCopy': 'My tech stack is always growing. Here\'s what I\'m getting to know right now.',
    'learning': [
      {
        'name': 'GraphQL',
      },


    ],
    'resumeLink': 'https://www.canva.com/design/DAFYjYgRh2U/-dWbni-s5-Vx3sctCYxPIA/view?utm_content=DAFYjYgRh2U&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink',
  },
  'projects': {
    'summary': 'I work very well on my own, and I thrive in collaborative coding environments. Here\'s a showcase of both my personal and collaborative projects.',
    'design-portfolio-link': 'https://benbeekman.com/web',

    'feature': [
      {
        'title': 'Paint Mixer',
        'description': 'I developed Paint Mixer, a tool for natural media artists, enabling them to create virtual palettes and explore color combinations through a precise paint mixing engine and user-friendly interface. This tool uses a blend of custom hooks, libraries, and utility functions for realistic paint simulation. I designed the architecture around reusable and self-contained components with full testing coverage that that segregate business logic from UI design.',
        'demo': 'https://paint-mixer.netlify.app/',
        'github': 'https://github.com/Palette-Pickers/paint-mixer',
        'tech': [
          {
            'name': 'JavaScript',
          },
          {
            'name': 'TypeScript',
          },
          {
            'name': 'React',
          },
          {
            'name': 'SASS',
          },
          {
            'name': 'Jest',
          },
          {
            'name': 'TravisCl',
          },
          {
            'name': 'GitHub'
          },
          {
            'name': 'Shell'
          },
          {
            'name': 'Netlify',
          },
          {
            'name': 'HTML',
          },
          {
            'name': 'CSS',
          },
        ],
      },
      {
        'title': 'Shapeways',
        'description': 'An interactive audiovisual composition, made possible by machine learning, and an exploration of new forms of expression and interaction. I developed Shapeways using React with a team of 5 people for a Machine Learning for Artists hackathon. My personal contributions included functions for real-time interpretation of a user\'s movement to generate dynamic musical performance seed data, for making API requests to several Magenta.JS musical performance machine learning models using that seed data, and for transforming the API responses into synth output, as well as improvements to the app\'s UX.',
        'demo': 'https://shapeways.netlify.app/',
        'github': 'https://github.com/whateverSpace/shapeways-frontend',
        'tech': [
          {
            'name': 'JavaScript',
          },
          {
            'name': 'React',
          },
          {
            'name': 'MagentaJS',
          },
          {
            'name': 'P5JS',
          },
          {
            'name': 'ML5',
          },
          {
            'name': 'ToneJS',
          },
          {
            'name': 'Jest',
          },
          {
            'name': 'TravisCl',
          },
          {
            'name': 'GitHub'
          },
          {
            'name': 'Shell'
          },
          {
            'name': 'Netlify',
          },
          {
            'name': 'HTML',
          },
          {
            'name': 'CSS',
          },
        ],
      },
      {
        'title': 'Virtual Fishtank',
        'description': 'A 3D fishtank simulator with dynamic animated fish movement, procedurally generated coral, collision detection and a 4K HDRI background. Developed in a 5-person team over two half-day code sprints for the Empathetech March Fo(u)rth Hackathon. My contributions included the programmatic fish decision-making, behavior variation, and animation.',
        'demo': 'https://virtual-fishtank.netlify.app/',
        'github': 'https://github.com/Empathetech-Fish-Game/fish-game',
        'tech': [
          {
            'name': 'JavaScript',
          },
          {
            'name': 'React',
          },
          {
            'name': 'ThreeJS',
          },
          {
            'name': 'GitHub'
          },
          {
            'name': 'Shell'
          },
          {
            'name': 'Netlify',
          },
          {
            'name': 'HTML',
          },
          {
            'name': 'CSS',
          },
        ],
      },
      {
        'title': 'Live Palette Populator',
        'description': 'A React app I designed and engineered with an uniquely efficient and intuitive UI for quickly creating and exploring flexible color palettes. I engineered it with experimentation and efficiency in mind, as a tool for quickly generating and exporting large or small collections of colors using any combination of color relationships and color modes.',
        'demo': 'https://live-palette-populator.netlify.app/',
        'github': 'https://github.com/beekman/live-palette-populator',
        'tech': [
          {
            'name': 'JavaScript',
          },
          {
            'name': 'React',
          },
          {
            'name': 'Jest',
          },
          {
            'name': 'TravisCl',
          },
          {
            'name': 'GitHub'
          },
          {
            'name': 'Shell'
          },
          {
            'name': 'Netlify',
          },
          {
            'name': 'HTML',
          },
          {
            'name': 'CSS',
          },
        ],
      },
      {
        'title': 'whateverSynth',
        'description': 'A JavaScript-based synthesizer app featuring MIDI and keyboard support, an unlimited effects chain with over 10 audio effects using tuna.js, pitch bend and modulation, instrument selection, and real-time waveform visualization. I built this app with three fellow musicians. Some of my most significant personal contributions relate to the user interface and UX engineering. I wrote and implemented many of the UI-oriented React components and hooks, including UI components used throughout the app that make manipulation of real-time effects more efficient, and most of the audio effects components.',
        'demo': 'https://whateversynthstaging.netlify.app/',
        'github': 'https://github.com/whateverSynth/whateverSynth-frontend',
        'tech': [
          {
            'name': 'JavaScript',
          },
          {
            'name': 'React',
          },
          {
            'name': 'Jest',
          },
          {
            'name': 'GitHub',
          },
          {
            'name': 'TravisCl',
          },
          {
            'name': 'Shell',
          },
          {
            'name': 'Netlify',
          },
          {
            'name': 'HTML',
          },
          {
            'name': 'CSS',
          },
        ],
      },
      {
        'title': 'kit: Keep In Touch',
        'description': 'A progressive web app for improving communication, with customizable scheduled push notifications and connection logs. Developed in a five person team over a four-day code sprint. My contributions centered around UX/UI engineering, the creation of React components for adding and editing contacts, and a responsive navigation menu system.',
        'github': 'https://github.com/band-m/friendlier-fe',
        'tech': [
          {
            'name': 'JavaScript',
          },
          {
            'name': 'React',
          },
          {
            'name': 'Redux',
          },
          {
            'name': 'Node',
          },
          {
            'name': 'Express',
          },
          {
            'name': 'MongoDB',
          },
          {
            'name': 'Jest',
          },
          {
            'name': 'GitHub'
          },
          {
            'name': 'Shell'
          },
          {
            'name': 'Netlify',
          },
          {
            'name': 'Heroku',
          },
          {
            'name': 'HTML',
          },
          {
            'name': 'CSS',
          },
        ],
      },
      {
        'title': 'Plant Parenthood',
        'description': 'A secure server-side IoT plant sensor application that allows users to remotely gather and post data collected from a variety of sensors (light, temperature, humidity) connected to a Raspberry Pi. Two-factor authentication ensures the integrity of data. Data can be interpreted to make recommendations of common house plants that may thrive under matching environmental conditions.',
        'github': 'https://github.com/piParty/pi-party',
        'tech': [
          {
            'name': 'JavaScript',
          },
          {
            'name': 'Node',
          },
          {
            'name': 'MongoDB',
          },
          {
            'name': 'Express',
          },
          {
            'name': 'Mongoose',
          },
          {
            'name': 'TravisCl',
          },
          {
            'name': 'GitHub',
          },
          {
            'name': 'Shell',
          },
          {
            'name': 'HTML',
          },
          {
            'name': 'CSS',
          },
          {
            'name': 'Python',
          },
          {
            'name': 'Flask'
          },
          {
            'name': 'Raspberry Pi',
          },
          {
            'name': 'Heroku'
          }
        ],
      },
      {
        'title': 'FrontPage',
        'description': 'A Tinder-style newsreader that allows you to swipe right on the news that interests you, and filter out news sources that you don\'t want to see.',
        'github': 'https://github.com/Alchemy-Frontpage/Frontpage',
        'tech': [
          {
            'name': 'JavaScript',
          },
          {
            'name': 'Node',
          },
          {
            'name': 'Express',
          },
          {
            'name': 'PostgreSQL',
          },
          {
            'name': 'GitHub',
          },
          {
            'name': 'TravisCl',
          },
          {
            'name': 'Shell'
          },
          {
            'name': 'HTML',
          },
          {
            'name': 'CSS',
          },
        ],
      },
      {
        'title': 'Qwixx',
        'description': 'A mobile-responsive vanilla JavaScript implementation of the dice game Qwixx that speeds gameplay and doesn\'t waste scorecards. Developed with face-to-face multiplayer in mind, with each player\'s device acting as their scorecard.',
        'demo': 'https://i-16.github.io/qwixx/',
        'github': 'https://github.com/I-16/qwixx',
        'tech': [
          {
            'name': 'JavaScript',
          },
          {
            'name': 'TravisCl',
          },
          {
            'name': 'HTML',
          },
          {
            'name': 'CSS',
          },
          {
            'name': 'GitHub'
          },
          {
            'name': 'Shell'
          },
        ],
      }
    ],
    'sitesTitle': 'Websites',
    'sitesSummary': 'I\'ve designed and developed websites for a variety of clients, including small businesses, nonprofits, and individuals. Here are a few of my favorites.',
    'site': [
      {
        'title': 'Erskine Solar Art',
        'image': 'erskineSolarArt',
        'link': 'https://erskinesolarart.net'
      },
      {
        'title': 'Freshops',
        'image': 'freshops',
        'link': 'https://freshops.com'
      },
      {
        'title': 'RSB Law',
        'image': 'rsbLaw',
        'link': 'http://www.rsblaw.net',
      },
      {
        'title': 'Johanna',
        'image': 'johanna',
        'link': 'https://johannasings.com',
      },
      {
        'title': 'Digital Planet',
        'image': 'digitalPlanet',
        'link': 'https://digitalplanet.net',
      },
      {
        'title': 'Oasis Life Design',
        'image': 'oasis',
        'link': 'https://oasislifedesign.com',
      },
    ]
  }
};
